module.exports = __webpack_public_path__ + "img/550.0edc2c15.jpg";